import React, { Component } from 'react';
import {
  confirmAccount,
  confirmationFailed,
  clearError
} from './ducks/actions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Alert, Row, Col, ControlLabel } from 'react-bootstrap';
import './style.css';
import logo from '../../../images/login-logo@1x.png';
class Confirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      confirm_password: '',
      birthday: '',
      serial_number: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isValid = this.isValid.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  isValid() {
    if (this.state.username.length < 6) {
      this.props.actions.confirmationFailed(
        'Username must be at least 6 characters long'
      );
      return false;
    }
    if (this.state.password !== this.state.confirm_password) {
      this.props.actions.confirmationFailed('Passwords do not match');
      return false;
    }
    if (this.state.password.length < 8) {
      this.props.actions.confirmationFailed(
        'Password must be at least 8 characters long'
      );
      return false;
    }
    return true;
  }

  handleDismiss() {
    this.props.actions.clearError();
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isValid()) {
      console.log('confirming');
      console.log(this.state);
      this.props.actions.confirmAccount(
        this.props.match.params.token,
        this.state.username.trim(),
        this.state.password,
        this.state.birthday,
        this.state.serial_number
      );
    }
  }

  render() {
    if (this.props.token) {
      return <Redirect to="/paystubs" />;
    }
    var errorMessage;
    if (this.props.error) {
      errorMessage = (
        <div className="row">
          <div className="col-sm-12">
            <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
              {this.props.error}
            </Alert>
          </div>
        </div>
      );
    }
    return (
      <div className="main-wrapper">
        <form onSubmit={this.handleSubmit} className="panel panel-default">
          <div className="panel-heading">
            <img src={logo} alt="ComputerEase" />
            <h3 className="panel-title">Employee Hub</h3>
          </div>
          <div className="panel-body">
            {errorMessage}
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Create Username</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-user-circle" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Username"
                    type="text"
                    name="username"
                    value={this.state.username}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Create Password</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-key" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Password"
                    type="password"
                    name="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Confirm Password</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-key" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Confirm Password"
                    type="password"
                    name="confirm_password"
                    value={this.state.confirm_password}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Birthday</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-birthday-cake" />
                  </div>
                  <input
                    className="form-control"
                    type="date"
                    name="birthday"
                    value={this.state.birthday}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Verify Last 4 Digits of SSN</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-address-card-o" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Last 4 of Social"
                    type="text"
                    name="serial_number"
                    value={this.state.serial_number}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <input
                  className="btn btn-lg btn-primary btn-block"
                  type="submit"
                  value="Register"
                />
              </Col>
            </Row>
          </div>
        </form>
        <p className="small footer-notes">
          <strong>
            Copyright © {new Date().getFullYear()} Deltek, Inc.<br />All rights
            reserved.<br />
            <a
              href="https://www.deltek.com/en/legal.aspx"
              target="privacy_policy"
              class="white"
            >
              Privacy Policy
            </a>
          </strong>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.confirmReducer.error,
    token: state.confirmReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      confirmAccount: (token, username, secret, birthday, serial_number) => {
        dispatch(
          confirmAccount(token, username, secret, birthday, serial_number)
        );
      },
      confirmationFailed: message => {
        dispatch(confirmationFailed(message));
      },
      clearError: () => {
        dispatch(clearError());
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Confirm);



// WEBPACK FOOTER //
// ./src/components/account/Confirm/index.js